import React from "react";

// Панель с центрированным заголовком. Подпись активных фильтров («· фильтр: …» / «· все записи»)
// передаётся как caption и берётся из общего состояния (store.filterCaption).
export default function Section({ title, caption, children }) {
  return (
    <div className="vsu-section">
      <div className="vsu-section-head">
        <span>{title}</span>
        {caption ? <span className="vsu-hp">{caption}</span> : null}
      </div>
      <div className="vsu-section-body">{children}</div>
    </div>
  );
}
